import { render, staticRenderFns } from "./ReportsPonderacionCharge.vue?vue&type=template&id=913aec66&"
import script from "./ReportsPonderacionCharge.vue?vue&type=script&lang=js&"
export * from "./ReportsPonderacionCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports